import { GET_SETTINGS,SET_APP_MODE  } from "./actionTypes";
import { AppMode } from "../../constants";

// Initialize app mode from localStorage or default to SPRINT
const getInitialAppMode = () => {
    const savedMode = localStorage.getItem('appMode');
    if (savedMode) {
        const mode = parseInt(savedMode, 10);
        // console.log('🔄 App mode loaded from localStorage:', mode);
        return mode;
    }
    // console.log('🔄 No saved app mode, defaulting to SPRINT');
    return AppMode.SPRINT; // Default to SPRINT mode
};

const initialState = {
    settings: [],
    appMode: getInitialAppMode(),
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_SETTINGS:
            return { ...state, settings: action.payload };
        case SET_APP_MODE:
            return { ...state, appMode: action.payload };
        default:
            return state;
    }
}
